import rootStore from '../stores/RootStore'

export interface RequestOptions {
  body?: string
  method?: string
  withCredentials?: boolean
  abortController?: AbortController
  retry?: boolean
  useCustomToken?: boolean
}

export default function BuildFetchRequest(options: RequestOptions): RequestInit {
  const authStore = rootStore.authStore
  const token = authStore.authToken
  const registrationToken = authStore.registrationToken
  const language = authStore.language || "en"

  const headers = new Headers({
    "Accept": "application/json",
    "Content-Type": "application/json",
    "Accept-Language": language
  })

  if (options.useCustomToken) {
    headers.append("X-Auth-Token", registrationToken ? `Bearer ${registrationToken}` : "")
  } else {
    headers.append("Authorization", token ? `Bearer ${token}` : "")
  }

  return {
    method: options.method ? options.method : (options.body ? "post" : "get"),
    credentials: options.withCredentials ? "include" : "omit",
    headers: headers,
    body: options?.body,
    signal: options.abortController?.signal
  }
}
